import { CatalogItem } from '../model/types/CatalogItemSchema';

export const getItemTotalAvailable = (item: CatalogItem): number =>
    (item.proposals ?? []).reduce(
        (acc, proposal) => acc + (proposal.availableQuantity || 0),
        0,
    );

export interface OrderLineQuantity {
    id: string;
    qty?: number;
}

export const getItemsOverQuantity = (
    items: CatalogItem[],
    orderLines: OrderLineQuantity[],
): CatalogItem[] =>
    items.filter((item) => {
        if (!item.selectedProposals) {
            return false;
        }

        const orderItemQty =
            orderLines.find((orderItem) => item.id === orderItem.id)?.qty || 0;

        return orderItemQty > getItemTotalAvailable(item);
    });
